export default __webpack_public_path__ + "static/media/cleaner2.abcac13e.jpg";